module.exports = __webpack_public_path__ + "img/number2.0aaf3dca.svg";